import { render, staticRenderFns } from "./Mejora.vue?vue&type=template&id=384edc6b&scoped=true&lang=html&"
import script from "./Mejora.vue?vue&type=script&lang=js&"
export * from "./Mejora.vue?vue&type=script&lang=js&"
import style0 from "./Mejora.vue?vue&type=style&index=0&id=384edc6b&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "384edc6b",
  null
  
)

export default component.exports